import { render, staticRenderFns } from "./SntSelect.vue?vue&type=template&id=3950a4b2&scoped=true&"
import script from "./SntSelect.vue?vue&type=script&lang=js&"
export * from "./SntSelect.vue?vue&type=script&lang=js&"
import style0 from "./SntSelect.vue?vue&type=style&index=0&id=3950a4b2&prod&lang=css&"
import style1 from "./SntSelect.vue?vue&type=style&index=1&id=3950a4b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950a4b2",
  null
  
)

export default component.exports